<template>
    <div class="card">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th v-sort:name>Название</th>
                        <th class="d-none d-lg-table-cell">Ингредиенты</th>
                        <th v-if="hasCrt" v-sort:vat class="d-none d-lg-table-cell">НДС</th>
                        <th class="action-buttons" />
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="recipe in recipes" :key="recipe.id">
                        <td class="truncate">{{ recipe.name }}</td>
                        <td class="d-none d-lg-table-cell">
                            <ul class="components-list">
                                <li v-for="component in recipe.components" :key="component.id">
                                    <span class="d-inline-block text-truncate" style="max-width: 100px">{{ component.name }}</span> <span class="float-right">{{ component.volume }} {{ component.unit | unit }}</span>
                                </li>
                            </ul>
                        </td>
                        <td v-if="hasCrt" class="d-none d-lg-table-cell">{{ recipe.vat | vat }}</td>

                        <td class="action-buttons">
                            <router-link :to="{ name: 'stocks.recipes.show', params: { id: recipe.id }}" class="btn btn-icon btn-edit shadow-none" />
                            <button type="button" class="btn btn-icon btn-remove shadow-none" @click.prevent="remove(recipe.id)" />
                        </td>
                    </tr>
                </tbody>

                <tfoot v-if="noOne" class="no-one">
                    <tr>
                        <td colspan="42">Вы пока не добавили ни одного рецепта.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="noFound" class="no-one">
                    <tr>
                        <td colspan="42">По вашему запросу не найдено ни одного рецепта.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="meta.last_page > 1">
                    <tr>
                        <td colspan="42">
                            <pagination :meta="meta" @input="applyFilter({ page: $event })" />
                        </td>
                    </tr>
                </tfoot>
            </table>

            <router-view />
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'

import store from '@/store'
import { toastSuccess, toastError, confirm, getUsageMessage } from '@/dialogs'

export default {
    components: {
        Pagination
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({})
        }
    },

    computed: {
        recipes() {
            return this.$store.state.stocks.data || []
        },

        meta() {
            return this.$store.state.stocks.meta || {}
        },

        isMobile() {
            return this.$store.state.isMobile
        },

        noOne() {
            return this.recipes.length === 0 && !this.filter.search
        },

        noFound() {
            return this.recipes.length === 0 && this.filter.search
        },

        hasCrt() {
            return this.$store.getters['company/hasCrt']
        }
    },

    methods: {
        async remove(id) {
            if (!await this.$store.dispatch('stocks/getUsage', id)) {
                return toastError('Ошибка')
            }

            if (!await confirm('Удалить?', getUsageMessage(this.$store.state.stocks.usage))) {
                return
            }

            let status = await this.$store.dispatch('stocks/remove', id)

            if (status) {
                toastSuccess('Удалено')
            } else {
                return toastError('Ошибка')
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch('stocks/fetchAll', { ...to.query, recipe: 1 })
        next()
    },

    async beforeRouteUpdate(to, from, next) {
        await store.dispatch('stocks/fetchAll', { ...to.query, recipe: 1 })
        next()
    }
}
</script>

<style lang="scss">
.components-list {
    padding: 0;
    margin: 0;

    li {
        display: block;
    }
}
</style>
